export default __webpack_public_path__ + "static/media/(33)-min.edddc345.jpg";